export interface CaseQueueScheduleRequest {
	startTime: string;
	endTime: string;
	recurrenceType: string;
	description: string;
	startDate?: string;
	endDate?: string;
	dayOfWeek?: string | null;
	includeWeekends?: boolean | null;
	dayOfMonth?: number | string | null; // String used for empty track var
	month?: number | string | null; // String used for empty track var
}

export interface ProviderCaseQueue {
	feed: string;
	description: string;
	id: string;
	startTime: string;
	endTime: string;
	recurrenceType: string;
	startDate?: string;
	endDate?: string;
	dayOfWeek?: string | null;
	includeWeekends?: boolean | null;
	dayOfMonth?: number | string | null; // String used for empty track var
	month?: number | string | null; // String used for empty track var
}

export const WEEK_DAYS = [
	'Monday',
	'Tuesday',
	'Wednesday',
	'Thursday',
	'Friday',
	'Saturday',
	'Sunday',
];

export const MONTHS = [
	'January',
	'February',
	'March',
	'April',
	'May',
	'June',
	'July',
	'August',
	'September',
	'October',
	'November',
	'December',
];
